import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SideBar  from '../../components/Topbar';
import { HTMLCourseNavProvider } from "../../components/SidebarCourseContext";
import { CopyBlock, dracula } from "react-code-blocks";



const PhpLesson10 = () => {
    const [language, changeLanguage] = useState("php");
    const [lineNumbers, toggleLineNumbers] = useState(false);
      const code = (
        'text',
        `
        <?php
          $num = 10; //integer
          $float = 3.142; //float
          $str = "Hello World!";  //string
          $bool = true;  //boolean
          $arr = array(1,2,3);  //array
          $obj = new person();  //object
          $null = null;  //null
         }
        ?>

        `
      );








  return(
    <HTMLCourseNavProvider>
    <div className="container">
    <div className="row">
    <div>
    <SideBar  />
    </div>
    <div className="col-md-12">


    <div className="alert alert-secondary" role="alert">

    <h3><strong>Data Types</strong></h3>
    <p>PHP supports a variety of data types, including:</p>
    <ol class="list-group list-group-numbered mb-4">
    <li class="list-group-item">Integers: Whole numbers, positive or negative (e.g. -5, 0, 100).</li>
    <li class="list-group-item">Floats: Numbers with a decimal point (e.g. 3.14, -2.5)</li>
    <li class="list-group-item">Strings: A series of characters, usually used to store text (e.g. "Hello World", "123456")</li>
    <li class="list-group-item">Booleans: A true or false value (true or false)</li>
    <li class="list-group-item">Arrays: An ordered list of values (e.g. array(1, 2, 3, 4))</li>
    <li class="list-group-item">NULL: A special data type that represents the absence of a value or a null value</li>
    <li class="list-group-item">Objects: A data type that represents a custom data structure (e.g. a person object with properties like name and age)</li>
    </ol>
    <p>PHP is a loosely typed language, which means that you don't need to specify the data type of a variable when you declare it.
    The data type of a variable will be determined automatically based on the value it is assigned.</p>
    <CopyBlock
    language={"php"}
    text={code}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />

    </div>




    </div>
    </div>
    </div>
    </HTMLCourseNavProvider>
  )
}
export default PhpLesson10
